var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_61_127)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FFEED5",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 32C31.1667 32 30.4583 31.7083 29.875 31.125C29.2917 30.5417 29 29.8333 29 29C29 28.8833 29.0083 28.7623 29.025 28.637C29.0417 28.5117 29.0667 28.3993 29.1 28.3L22.05 24.2C21.7667 24.45 21.45 24.646 21.1 24.788C20.75 24.93 20.3833 25.0007 20 25C19.1667 25 18.4583 24.7083 17.875 24.125C17.2917 23.5417 17 22.8333 17 22C17 21.1667 17.2917 20.4583 17.875 19.875C18.4583 19.2917 19.1667 19 20 19C20.3833 19 20.75 19.071 21.1 19.213C21.45 19.355 21.7667 19.5507 22.05 19.8L29.1 15.7C29.0667 15.6 29.0417 15.4877 29.025 15.363C29.0083 15.2383 29 15.1173 29 15C29 14.1667 29.2917 13.4583 29.875 12.875C30.4583 12.2917 31.1667 12 32 12C32.8333 12 33.5417 12.2917 34.125 12.875C34.7083 13.4583 35 14.1667 35 15C35 15.8333 34.7083 16.5417 34.125 17.125C33.5417 17.7083 32.8333 18 32 18C31.6167 18 31.25 17.9293 30.9 17.788C30.55 17.6467 30.2333 17.4507 29.95 17.2L22.9 21.3C22.9333 21.4 22.9583 21.5127 22.975 21.638C22.9917 21.7633 23 21.884 23 22C23 22.116 22.9917 22.237 22.975 22.363C22.9583 22.489 22.9333 22.6013 22.9 22.7L29.95 26.8C30.2333 26.55 30.55 26.3543 30.9 26.213C31.25 26.0717 31.6167 26.0007 32 26C32.8333 26 33.5417 26.2917 34.125 26.875C34.7083 27.4583 35 28.1667 35 29C35 29.8333 34.7083 30.5417 34.125 31.125C33.5417 31.7083 32.8333 32 32 32Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_61_127",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_61_127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_61_127",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b37e8e3b5054bdda5d556a4df6d638b8.svg";
export { ForwardRef as ReactComponent };